/**
 * Which admin queues have a **server** search, and what to call them (M24-T05).
 *
 * ADR-0050 names four endpoints that accept `?q=` and searches the whole queue;
 * the other eight filter the rows already on screen. This is the one place that
 * list is written down.
 *
 * **A page registers itself by importing from here**, rather than the shell
 * matching on `pathname`. A route-path map is the obvious design and it rots:
 * rename a route and the map still claims a server search that no longer
 * happens, and the box then renders a confident "no results" for a query that
 * never ran — which is the same harm M24-T03 exists to remove. The call site
 * that declares the search is the call site that sends `q`, so the two cannot
 * drift.
 *
 * The label completes the sentence "Search …" in the box, and names the queue
 * so an admin can see at a glance that this box reaches further than the one on
 * the page they were just looking at.
 */
export const SEARCHABLE = {
  appointments: 'appointments',
  diagnostics: 'diagnostics',
  emergency: 'emergency leads',
  enquiries: 'enquiries',
  // `leads` covers BOTH segments of the Leads page — procedure leads and
  // specialist leads are two endpoints under one box, and both now take `q`
  // (M25-T01). Registering it while only one of them searched would let the
  // box claim the whole queue was covered when half of it was never queried.
  leads: 'leads',
} as const

export type SearchableQueue = (typeof SEARCHABLE)[keyof typeof SEARCHABLE]
